/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import _ from 'lodash';
import {Ng2StateDeclaration} from '@uirouter/angular';
import {AdminResourceItemRoutePageComponent} from '../common/controller/admin-resource-item-route-page.component';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {orderListCommons} from './order-commons';
import {adminResourceItemRouteResolve} from '../common/controller/admin-resource-routing';
import {OrderContextActionsComponent} from './order-context-actions.component';
import {LineItemResource} from '../../components/api/resources/resource/line-item.resource';
import {OrderResource} from '../../components/api/resources/resource/order.resource';

const listTemplate = '<adn-order-list-page [list]="list"></adn-order-list-page>';

export function orderStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
let rh = adnRouterHelperProvider.$get().createRouterAndChildHelper('orders.order', OrderResource, LineItemResource, 'app.adv', 'app', listTemplate);
        $stateProvider.state(rh.listPath(), rh.list({
          resolve: {
            extension: /*@ngInject*/ function() {
              const LocalNetworkProfile = adnRouterHelper.services.localNetworkProfile();
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return {
                func: function(ctrl, afterFill) {
                  orderListCommons(ctrl, afterFill, LocalNetworkProfile, LocalUserPermissions);
                }
              };
            },
            sectionParam: function() {
              return 'orders';
            }
          }
        }))
          .state(rh.newItemPath(), rh.newItem())
          .state(rh.itemPath(), rh.modelCommsItem({
            resolve: _.merge({}, adminResourceItemRouteResolve('order-item', 'item')),
            views: {
              'content@app': { component: AdminResourceItemRoutePageComponent, bindings: { item: 'adminResourceItemKey', variant: 'adminResourceItemVariant' }  },
              'context@app': {
                component: OrderContextActionsComponent,
                bindings: {model: 'model', modelComms: 'modelComms', isNew: 'isNew', readOnly: 'readOnly'}
              }
            }
          }, 'Order', [{type: 'Advertiser', func: 'canBeShownAdvertiser'}]));
  }, adnRouterHelper);
}
